<template>
  <div class="profile-container">
    <el-card shadow="never" class="box-card">
      <!-- 头部标题与预览操作 -->
      <div slot="header" class="card-header">
        <div class="title-wrapper">
          <i class="el-icon-user-solid header-icon" />
          <span class="title-text">个人档案详细信息录入</span>
          <span class="sub-title">请填写您的个人基本资料及多维经历档案</span>
        </div>
        <div class="header-action">
          <el-button
            type="primary"
            icon="el-icon-view"
            size="small"
            @click="handlePreview"
          >
            预览档案
          </el-button>
        </div>
      </div>

      <!-- 表单主体 -->
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small"
      >
        <!-- ==================== 一、 基本信息 ==================== -->
        <div class="section-title"><i class="el-icon-s-custom" /> 基本信息</div>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="性别" prop="gender">
              <el-select v-model="form.gender" placeholder="请选择性别" style="width: 100%" clearable>
                <el-option label="男" value="男" />
                <el-option label="女" value="女" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="出生日期" prop="birthDate">
              <el-date-picker
                v-model="form.birthDate"
                type="date"
                placeholder="选择出生日期"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="籍贯" prop="nativePlace">
              <el-cascader
                v-model="form.nativePlace"
                :options="regionOptions"
                placeholder="请选择省/市/县"
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="民族" prop="ethnicity">
              <el-select v-model="form.ethnicity" placeholder="请选择民族" style="width: 100%" filterable clearable>
                <el-option label="汉族" value="汉族" />
                <el-option label="蒙古族" value="蒙古族" />
                <el-option label="回族" value="回族" />
                <el-option label="藏族" value="藏族" />
                <el-option label="维吾尔族" value="维吾尔族" />
                <el-option label="苗族" value="苗族" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="政治面貌" prop="politicalStatus">
              <el-select v-model="form.politicalStatus" placeholder="请选择政治面貌" style="width: 100%" clearable>
                <el-option label="中共党员" value="中共党员" />
                <el-option label="共青团员" value="共青团员" />
                <el-option label="群众" value="群众" />
                <el-option label="民主党派" value="民主党派" />
                <el-option label="无党派人士" value="无党派人士" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="form.idCard" placeholder="请输入18位身份证号" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入手机号" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="学历" prop="education">
              <el-select v-model="form.education" placeholder="请选择学历" style="width: 100%" clearable>
                <el-option label="小学" value="小学" />
                <el-option label="初中" value="初中" />
                <el-option label="高中/中专" value="高中/中专" />
                <el-option label="大专" value="大专" />
                <el-option label="本科" value="本科" />
                <el-option label="硕士研究生" value="硕士研究生" />
                <el-option label="博士研究生" value="博士研究生" />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 户籍地址 -->
          <el-col :xs="24" :sm="24" :md="16">
            <el-form-item label="户籍地址" required>
              <el-col :span="11" style="padding-left: 0; padding-right: 5px;">
                <el-form-item prop="householdRegion">
                  <el-cascader
                    v-model="form.householdRegion"
                    :options="regionOptions"
                    placeholder="请选择省/市/县"
                    style="width: 100%"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="13" style="padding-left: 5px; padding-right: 0;">
                <el-form-item prop="householdDetail">
                  <el-input v-model="form.householdDetail" placeholder="请输入具体街道、门牌号等" clearable />
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>

          <!-- 居住地址 -->
          <el-col :xs="24" :sm="24" :md="16">
            <el-form-item label="居住地址" required>
              <el-col :span="11" style="padding-left: 0; padding-right: 5px;">
                <el-form-item prop="livingRegion">
                  <el-cascader
                    v-model="form.livingRegion"
                    :options="regionOptions"
                    placeholder="请选择省/市/县"
                    style="width: 100%"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="13" style="padding-left: 5px; padding-right: 0;">
                <el-form-item prop="livingDetail">
                  <el-input v-model="form.livingDetail" placeholder="请输入具体街道、门牌号等" clearable />
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider />

        <!-- ==================== 二、 家庭成员 ==================== -->
        <div class="section-header">
          <div class="section-title" style="margin: 0;"><i class="el-icon-s-home" /> 家庭成员</div>
          <el-button type="success" icon="el-icon-plus" size="mini" plain @click="addFamilyMember">添加成员</el-button>
        </div>
        <div v-for="(item, index) in form.familyMembers" :key="'fam-' + index" class="repeater-item">
          <el-row :gutter="10" type="flex" align="middle" style="margin-bottom: 8px;">
            <el-col :span="8">
              <el-select v-model="item.relation" placeholder="请选择关系" size="small" style="width: 100%" filterable allow-create clearable>
                <el-option label="父亲" value="父亲" />
                <el-option label="母亲" value="母亲" />
                <el-option label="配偶" value="配偶" />
                <el-option label="子女" value="子女" />
                <el-option label="兄弟" value="兄弟" />
                <el-option label="姐妹" value="姐妹" />
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-input v-model="item.name" placeholder="成员姓名" size="small" />
            </el-col>
            <el-col :span="6">
              <el-input v-model="item.phone" placeholder="手机号" size="small" />
            </el-col>
            <el-col :span="2" align="center">
              <el-button type="text" icon="el-icon-delete" class="text-danger" @click="removeFamilyMember(index)">删除</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" align="middle">
            <el-col :span="22">
              <el-input v-model="item.idCard" placeholder="成员身份证号" size="small" />
            </el-col>
            <el-col :span="2" />
          </el-row>
        </div>
        <el-empty v-if="form.familyMembers.length === 0" description="暂无家庭成员记录" :image-size="60" />

        <el-divider />

        <!-- ==================== 三、 教育经历 ==================== -->
        <div class="section-header">
          <div class="section-title" style="margin: 0;"><i class="el-icon-reading" /> 教育经历</div>
          <el-button type="success" icon="el-icon-plus" size="mini" plain @click="addEducation">添加经历</el-button>
        </div>
        <div v-for="(item, index) in form.educationHistory" :key="'edu-' + index" class="repeater-item">
          <el-row :gutter="10" type="flex" align="middle" style="margin-bottom: 8px;">
            <el-col :span="22">
              <el-input v-model="item.schoolName" placeholder="学校名称" size="small" />
            </el-col>
            <el-col :span="2" align="center">
              <el-button type="text" icon="el-icon-delete" class="text-danger" @click="removeEducation(index)">删除</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" align="middle" style="margin-bottom: 8px;">
            <el-col :span="11">
              <el-cascader
                v-model="item.schoolRegion"
                :options="regionOptions"
                placeholder="请选择学校省/市/县"
                size="small"
                style="width: 100%"
                clearable
              />
            </el-col>
            <el-col :span="11">
              <el-input v-model="item.schoolDetail" placeholder="请输入具体学校详细地址" size="small" />
            </el-col>
            <el-col :span="2" />
          </el-row>
          <el-row :gutter="10" type="flex" align="middle">
            <el-col :span="22">
              <el-date-picker
                v-model="item.timeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="入学时间"
                end-placeholder="毕业时间"
                size="small"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              />
            </el-col>
            <el-col :span="2" />
          </el-row>
        </div>
        <el-empty v-if="form.educationHistory.length === 0" description="暂无教育经历记录" :image-size="60" />

        <el-divider />

        <!-- ==================== 四、 工作经历 ==================== -->
        <div class="section-header">
          <div class="section-title" style="margin: 0;"><i class="el-icon-s-cooperation" /> 工作经历</div>
          <el-button type="success" icon="el-icon-plus" size="mini" plain @click="addWork">添加经历</el-button>
        </div>
        <div v-for="(item, index) in form.workHistory" :key="'work-' + index" class="repeater-item">
          <el-row :gutter="10" type="flex" align="middle" style="margin-bottom: 8px;">
            <el-col :span="12">
              <el-input v-model="item.companyName" placeholder="公司名称" size="small" />
            </el-col>
            <el-col :span="10">
              <el-input v-model="item.position" placeholder="担任职位" size="small" />
            </el-col>
            <el-col :span="2" align="center">
              <el-button type="text" icon="el-icon-delete" class="text-danger" @click="removeWork(index)">删除</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" align="middle" style="margin-bottom: 8px;">
            <el-col :span="11">
              <el-cascader
                v-model="item.companyRegion"
                :options="regionOptions"
                placeholder="请选择公司省/市/县"
                size="small"
                style="width: 100%"
                clearable
              />
            </el-col>
            <el-col :span="11">
              <el-input v-model="item.companyDetail" placeholder="请输入具体公司详细地址" size="small" />
            </el-col>
            <el-col :span="2" />
          </el-row>
          <el-row :gutter="10" type="flex" align="middle">
            <el-col :span="12">
              <el-date-picker
                v-model="item.timeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="入职时间"
                end-placeholder="离职时间"
                size="small"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              />
            </el-col>
            <el-col :span="10">
              <el-input v-model="item.income" placeholder="年收入" size="small" />
            </el-col>
            <el-col :span="2" />
          </el-row>
        </div>
        <el-empty v-if="form.workHistory.length === 0" description="暂无工作经历记录" :image-size="60" />

        <el-divider />

        <!-- ==================== 五、 感情经历 ==================== -->
        <div class="section-header">
          <div class="section-title" style="margin: 0;"><i class="el-icon-star-on" /> 感情经历</div>
          <el-button type="success" icon="el-icon-plus" size="mini" plain @click="addRelationship">添加经历</el-button>
        </div>
        <div v-for="(item, index) in form.relationshipHistory" :key="'rel-' + index" class="repeater-item">
          <el-row :gutter="10" type="flex" align="middle" style="margin-bottom: 8px;">
            <el-col :span="7">
              <el-input v-model="item.partner" placeholder="对象名" size="small" />
            </el-col>
            <el-col :span="7">
              <el-input v-model="item.phone" placeholder="手机号" size="small" />
            </el-col>
            <el-col :span="8">
              <el-select v-model="item.intimacyLevel" placeholder="交往程度" size="small" style="width: 100%">
                <el-option label="初级好感" value="初级好感" />
                <el-option label="热恋阶段" value="热恋阶段" />
                <el-option label="深度磨合" value="深度磨合" />
              </el-select>
            </el-col>
            <el-col :span="2" align="center">
              <el-button type="text" icon="el-icon-delete" class="text-danger" @click="removeRelationship(index)">删除</el-button>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" align="middle" style="margin-bottom: 8px;">
            <el-col :span="12">
              <el-input v-model="item.idCard" placeholder="对象身份证号" size="small" />
            </el-col>
            <el-col :span="10">
              <el-select v-model="item.relationshipStatus" placeholder="发展阶段" size="small" style="width: 100%">
                <el-option label="恋爱中" value="恋爱中" />
                <el-option label="已订婚" value="已订婚" />
                <el-option label="已婚" value="已婚" />
                <el-option label="已分手/离异" value="已分手/离异" />
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="10" type="flex" align="middle">
            <el-col :span="22">
              <el-date-picker
                v-model="item.timeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                size="small"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              />
            </el-col>
          </el-row>
        </div>
        <el-empty v-if="form.relationshipHistory.length === 0" description="暂无感情经历记录" :image-size="60" />

        <!-- 底部提交/预览操作栏 -->
        <div class="form-footer">
          <el-button type="primary" icon="el-icon-view" size="medium" @click="handleSave">保存</el-button>
        </div>
      </el-form>
    </el-card>

    <!-- 档案预览对话框 -->
    <el-dialog
      title="📄 个人完整档案预览"
      :visible.sync="showPreviewDialog"
      width="900px"
      center
      append-to-body
      custom-class="preview-dialog"
    >
      <div id="printArea" class="preview-content">
        <div class="preview-header">
          <h2>{{ form.name || '未填写姓名' }} 的个人档案</h2>
          <p>基本档案与多维经历汇总报告</p>
        </div>

        <!-- 基本信息展示 -->
        <h4 class="preview-section-title"><i class="el-icon-s-custom" /> 基本信息</h4>
        <el-descriptions :column="3" border size="small">
          <el-descriptions-item label="姓名">{{ form.name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="性别">{{ form.gender || '-' }}</el-descriptions-item>
          <el-descriptions-item label="出生日期">{{ form.birthDate || '-' }}</el-descriptions-item>
          <el-descriptions-item label="籍贯">{{ formatRegion(form.nativePlace) }}</el-descriptions-item>
          <el-descriptions-item label="民族">{{ form.ethnicity || '-' }}</el-descriptions-item>
          <el-descriptions-item label="政治面貌">{{ form.politicalStatus || '-' }}</el-descriptions-item>
          <el-descriptions-item label="身份证号" :span="2">{{ form.idCard || '-' }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ form.phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="学历" :span="3">{{ form.education || '-' }}</el-descriptions-item>
          <el-descriptions-item label="户籍地址" :span="3">
            {{ formatRegion(form.householdRegion) }} {{ form.householdDetail || '' }}
          </el-descriptions-item>
          <el-descriptions-item label="居住地址" :span="3">
            {{ formatRegion(form.livingRegion) }} {{ form.livingDetail || '' }}
          </el-descriptions-item>
        </el-descriptions>

        <!-- 家庭成员展示 -->
        <h4 class="preview-section-title"><i class="el-icon-s-home" /> 家庭成员</h4>
        <el-table v-if="form.familyMembers.length > 0" :data="form.familyMembers" border size="mini" style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="relation" label="关系" width="100" />
          <el-table-column prop="name" label="姓名" width="120" />
          <el-table-column prop="idCard" label="身份证号" min-width="160" />
          <el-table-column prop="phone" label="手机号" width="130" />
        </el-table>
        <p v-else class="preview-empty">暂无记录</p>

        <!-- 教育经历展示 -->
        <h4 class="preview-section-title"><i class="el-icon-reading" /> 教育经历</h4>
        <el-table v-if="form.educationHistory.length > 0" :data="form.educationHistory" border size="mini" style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="schoolName" label="学校名" width="140" />
          <el-table-column label="学校地址" min-width="180">
            <template slot-scope="scope">
              {{ formatRegion(scope.row.schoolRegion) }} {{ scope.row.schoolDetail || '' }}
            </template>
          </el-table-column>
          <el-table-column label="起始时间" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.timeRange ? scope.row.timeRange.join(' 至 ') : '-' }}
            </template>
          </el-table-column>
        </el-table>
        <p v-else class="preview-empty">暂无记录</p>

        <!-- 工作经历展示 -->
        <h4 class="preview-section-title"><i class="el-icon-s-cooperation" /> 工作经历</h4>
        <el-table v-if="form.workHistory.length > 0" :data="form.workHistory" border size="mini" style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="companyName" label="公司名" width="130" />
          <el-table-column prop="position" label="职位" width="100" />
          <el-table-column label="公司地址" min-width="180">
            <template slot-scope="scope">
              {{ formatRegion(scope.row.companyRegion) }} {{ scope.row.companyDetail || '' }}
            </template>
          </el-table-column>
          <el-table-column label="起始时间" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.timeRange ? scope.row.timeRange.join(' 至 ') : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="income" label="年收入" width="90" />
        </el-table>
        <p v-else class="preview-empty">暂无记录</p>

        <!-- 感情经历展示 -->
        <h4 class="preview-section-title"><i class="el-icon-star-on" /> 感情经历</h4>
        <el-table v-if="form.relationshipHistory.length > 0" :data="form.relationshipHistory" border size="mini" style="width: 100%">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="partner" label="对象" width="100" />
          <el-table-column prop="idCard" label="对象身份证号" min-width="160" />
          <el-table-column prop="phone" label="手机号" width="120" />
          <el-table-column prop="intimacyLevel" label="交往程度" width="100" />
          <el-table-column prop="relationshipStatus" label="发展阶段" width="100" />
          <el-table-column label="起始时间" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.timeRange ? scope.row.timeRange.join(' 至 ') : '-' }}
            </template>
          </el-table-column>
        </el-table>
        <p v-else class="preview-empty">暂无记录</p>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showPreviewDialog = false">关 闭</el-button>
        <el-button type="primary" size="small" icon="el-icon-printer" @click="handlePrint">打印 / 导出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPersonalData, addPersonalData } from '@/api/user'

export default {
  name: 'UserProfileForm',
  data() {
    return {
      form: {
        name: '',
        gender: '',
        birthDate: '',
        nativePlace: [],
        ethnicity: '',
        politicalStatus: '',
        idCard: '',
        phone: '',
        education: '',
        householdRegion: [],
        householdDetail: '',
        livingRegion: [],
        livingDetail: '',
        familyMembers: [],
        educationHistory: [],
        workHistory: [],
        relationshipHistory: []
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        birthDate: [{ required: true, message: '请选择出生日期', trigger: 'change' }],
        nativePlace: [{ required: true, message: '请选择籍贯', trigger: 'change' }],
        ethnicity: [{ required: true, message: '请选择民族', trigger: 'change' }],
        politicalStatus: [{ required: true, message: '请选择政治面貌', trigger: 'change' }],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号格式', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        education: [{ required: true, message: '请选择学历', trigger: 'change' }],
        householdRegion: [{ required: true, message: '请选择户籍省市区', trigger: 'change' }],
        householdDetail: [{ required: true, message: '请输入具体户籍地址', trigger: 'blur' }],
        livingRegion: [{ required: true, message: '请选择居住省市区', trigger: 'change' }],
        livingDetail: [{ required: true, message: '请输入具体居住地址', trigger: 'blur' }]
      },
      regionOptions: [
        {
          value: '北京市',
          label: '北京市',
          children: [{ value: '北京市', label: '北京市', children: [{ value: '东城区', label: '东城区' }, { value: '西城区', label: '西城区' }] }]
        },
        {
          value: '浙江省',
          label: '浙江省',
          children: [{ value: '杭州市', label: '杭州市', children: [{ value: '西湖区', label: '西湖区' }, { value: '余杭区', label: '余杭区' }] }]
        },
        {
          value: '广东省',
          label: '广东省',
          children: [{ value: '深圳市', label: '深圳市', children: [{ value: '南山区', label: '南山区' }, { value: '福田区', label: '福田区' }] }]
        }
      ],
      showPreviewDialog: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      getPersonalData().then(resp => {
        if (resp.code === 0) {
          this.form = resp.data
        } else {
          this.$message.warning(resp.msg)
        }
      })
    },
    addFamilyMember() {
      this.form.familyMembers.push({ relation: '', name: '', idCard: '', phone: '' })
    },
    removeFamilyMember(index) {
      this.form.familyMembers.splice(index, 1)
    },
    addEducation() {
      this.form.educationHistory.push({ schoolName: '', schoolRegion: [], schoolDetail: '', timeRange: [] })
    },
    removeEducation(index) {
      this.form.educationHistory.splice(index, 1)
    },
    addWork() {
      this.form.workHistory.push({ companyName: '', companyRegion: [], companyDetail: '', position: '', timeRange: [], income: '' })
    },
    removeWork(index) {
      this.form.workHistory.splice(index, 1)
    },
    addRelationship() {
      this.form.relationshipHistory.push({ partner: '', idCard: '', phone: '', intimacyLevel: '', relationshipStatus: '', timeRange: [] })
    },
    removeRelationship(index) {
      this.form.relationshipHistory.splice(index, 1)
    },
    formatRegion(val) {
      if (!val || val.length === 0) return '-'
      return val.join(' / ')
    },
    handlePreview() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.showPreviewDialog = true
        } else {
          this.$message.warning('请先完整填写基本信息中的必填项！')
          return false
        }
      })
    },
    handlePrint() {
      window.print()
    },
    handleSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          addPersonalData(this.form).then(resp => {
            if (resp.code === 0) {
              this.$message.success('档案保存成功！')
            }
          })
        } else {
          this.$message.warning('请检查基本信息中的必填项是否完整填写！')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.profile-container {
  padding: 24px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.box-card {
  border-radius: 8px;
  border: 1px solid #e6ebf5;
  max-width: 1100px;
  margin: 0 auto;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-wrapper {
  display: flex;
  align-items: center;
}

.header-icon {
  font-size: 22px;
  color: #409eff;
  margin-right: 8px;
}

.title-text {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.sub-title {
  font-size: 12px;
  color: #909399;
  margin-left: 12px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin: 16px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.repeater-item {
  background-color: #fafbfc;
  border: 1px dashed #dcdfe6;
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 10px;
}

.text-danger {
  color: #f56c6c;
}

.form-footer {
  margin-top: 30px;
  text-align: center;
}

.preview-content {
  padding: 10px 20px;
}

.preview-header {
  text-align: center;
  margin-bottom: 20px;
}

.preview-header h2 {
  margin: 0 0 5px 0;
  color: #303133;
}

.preview-header p {
  margin: 0;
  color: #909399;
  font-size: 13px;
}

.preview-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
  border-bottom: 2px solid #ecf5ff;
  padding-bottom: 6px;
  margin: 20px 0 10px 0;
}

.preview-empty {
  font-size: 12px;
  color: #909399;
  text-align: center;
  padding: 10px 0;
  background: #f9fafc;
  border-radius: 4px;
}

.dialog-footer {
  text-align: right;
}
</style>
